export default "__VITE_ASSET__e2JIdN4y__"